<h1>
  Impressum <br>
  IDOGO GmbH
</h1>
<p>
  <b>Angaben gemäß § 5 TMG</b> <br>
  IDOGO® GmbH • Fam. Tjoa<br>
  Böheimstraße 47/1<br>
  70199 Stuttgart<br>
  Deutschland
  <br><br>
  <b>Vertreten durch</b><br>
  Ping Liong Tjoa, Daniel Tjoa und Susanne Tjoa
  <br><br>
  <b>Kontakt</b><br>
  Telefon: +49 (0)711 / 62 00 725-1<br>
  Telefax: +49 (0)711 / 62 00 725-3<br>
  E-Mail: info@idogo.de
  <br><br>
  <b>Umsatzsteuer</b><br>
  Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br>
  DE283410640
  <br><br>
  <b>Angaben zur Betriebshaftpflichtversicherung</b><br>
  Allianz Versicherungs-Aktiengesellschaft<br>
  Königinstr. 28, 80802 München<br>
  Telefonnummer: +49 89 3800-0<br>
  E-Mail Sammelpostfach: info@allianz.de
  <br><br>
  Geltungsraum der Versicherung: Deutschland
  <br><br>
  <b>Streitschlichtung</b><br>
  Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr.
  Unsere E-Mail-Adresse finden Sie oben im Impressum.
  <br><br>
  Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
  <br><br>
  <b>Haftung für Inhalte</b><br>
  Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
  <br><br>
  Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
  <br><br>
  <b>Haftung für Links</b><br>
  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
  <br><br>
  Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
  <br><br>
  <b>Urheberrecht</b><br>
  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
  <br><br>
  Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
  <br>
  Quelle: www.e-recht24.de
  <br><br>
  <b>Copyright Information</b><br>
  Sämtliche Texte, Bilder und andere auf der Internetseite veröffentlichten Werke unterliegen - sofern nicht anders gekennzeichnet - dem Copyright der IDOGO® GmbH. Jede Vervielfältigung, Verbreitung, Speicherung, Übermittlung, Sendung und Wieder- bzw. Weitergabe der Inhalte ist ohne schriftliche Genehmigung ausdrücklich untersagt.
  <br><br>
  <b>Bildnachweis</b> <br>
  <a href="https://unsplash.com/">unsplash.com/</a>
  <br><br>
  <b>Website Umsetzung</b><br>
  <a href="https://heer.dev" target="_blanc">
    heer.dev | Programmierung und Webdesign
  </a>
</p>
